// Bundle progress bar (snippets/cart-upsell.liquid). Delegated, so it keeps working
// when the cart or cart notification is re-rendered through the Section Rendering API.

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-upsell-switch]');
  if (!button || button.disabled) return;

  const error = button.closest('[data-cart-upsell]').querySelector('.cart-upsell__error');
  const updates = { [button.dataset.removeId]: 0, [button.dataset.addId]: 1 };

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (error) error.hidden = true;

  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      if (!response.ok) throw new Error(response.statusText);
      if (button.dataset.redirect) {
        window.location.href = button.dataset.redirect;
      } else {
        window.location.reload();
      }
    })
    .catch(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (error) error.hidden = false;
    });
});

// Tooltips: hover or keyboard focus shows them; a tap toggles them (touch screens don't
// hover or focus buttons reliably); a tap elsewhere or Escape closes them (WCAG 1.4.13).
const closeCartUpsellTips = (except) => {
  document.querySelectorAll('.cart-upsell__info.is-open').forEach((info) => {
    if (info !== except) {
      info.classList.remove('is-open');
      info.setAttribute('aria-expanded', 'false');
    }
  });
};

// pointerdown, not click: iOS Safari doesn't send clicks from plain text to document.
document.addEventListener('pointerdown', (event) => {
  closeCartUpsellTips(event.target.closest('.cart-upsell__info'));
});

document.addEventListener('click', (event) => {
  const info = event.target.closest('.cart-upsell__info');
  if (!info) return;
  const open = !info.classList.contains('is-open');
  info.classList.toggle('is-open', open);
  info.classList.toggle('is-dismissed', !open);
  info.setAttribute('aria-expanded', String(open));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeCartUpsellTips();
  document.querySelectorAll('.cart-upsell__info:hover, .cart-upsell__info:focus').forEach((info) => {
    info.classList.add('is-dismissed');
  });
});

['focusout', 'mouseout'].forEach((type) => {
  document.addEventListener(type, (event) => {
    const info = event.target.closest && event.target.closest('.cart-upsell__info');
    if (info && !info.contains(event.relatedTarget)) info.classList.remove('is-dismissed');
  });
});

// Cart notification: if the bar makes the popup taller than the screen, cap it to the
// space below the header and let it scroll, so "Check out" always stays reachable.
const fitCartNotification = () => {
  const notification = document.querySelector('.cart-notification');
  if (!notification) return;
  if (!notification.querySelector('.cart-upsell-wrap')) {
    notification.style.removeProperty('max-height');
    notification.style.removeProperty('overflow-y');
    return;
  }
  const parentTop = notification.offsetParent ? notification.offsetParent.getBoundingClientRect().top : 0;
  const top = Math.max(parentTop + notification.offsetTop, 0);
  notification.style.maxHeight = `${Math.max(window.innerHeight - top, 240)}px`;
  notification.style.overflowY = 'auto';
};

const cartNotificationProduct = document.getElementById('cart-notification-product');
if (cartNotificationProduct) {
  new MutationObserver(fitCartNotification).observe(cartNotificationProduct, { childList: true, subtree: true });
  window.addEventListener('resize', fitCartNotification);
  window.addEventListener('scroll', fitCartNotification, { passive: true });
}
